import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, track } from "@/lib/tracking";

// Mounted once inside the router. Captures UTM attribution and fires a page_view per route.
export const AttributionTracker = () => {
  const location = useLocation();
  useEffect(() => {
    captureAttribution();
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("avb_ref", ref);
      track("referral_click", { code: ref });
    }
    track("page_view", { path: location.pathname });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return null;
};
